import React from "react";

import {
    Image,
    Platform,
    Text,
    TouchableOpacity,
    TouchableOpacityProps,
    View
} from "react-native";
import Activity from "../../../models/Activity";
import Images from "../../../../specific/utils/Images";
import AppTheme from "../../../utils/Theme";
import { getLanguage } from "../../../utils/Localization/Localization";
import User from "../../../data/user/User";
import { getMenuConfiguration, LEVEL_CONF } from "../../Menu/MenuConf";

interface ActivitySquareButtonProps extends TouchableOpacityProps {
    activity: Activity;
}

const ActivitySquareButton = (props: ActivitySquareButtonProps) => {

    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();

    const user: User = User.getInstance();
    const levelConfiguration: LEVEL_CONF = getMenuConfiguration(user.children_level);

    const { activity, ...restProps } = props;

    const refWidth = Platform.OS === "web" ? appTheme.getBlockWidth() : appTheme.getFullAppWidth();
    let cellSize = (refWidth - appTheme.pixelPerfect(60)) / 3;
    let imageSize = appTheme.pixelPerfect(80);
    if (imageSize > (cellSize - appTheme.pixelPerfect(10))) {
        imageSize = cellSize - appTheme.pixelPerfect(10);
    }

    // On va chercher l'image de la première activité de la catégorie
    let activityImage: number | { uri: string } | undefined = undefined;
    if ((activity.img_url !== undefined) && (activity.img_url.length > 0)) {
        activityImage = { uri: activity.img_url };
    }
    if ((activity.app_image !== undefined) && (activity.app_image.length > 0) && (images[activity.app_image] !== undefined)) {
        activityImage = images[activity.app_image];
    }
    return <TouchableOpacity key={activity.key} style={{ width: cellSize, alignItems: "center", justifyContent: "center" }} {...restProps}>
        <Image source={activityImage} style={{ width: imageSize, height: imageSize, borderRadius: 20 }} resizeMode="cover" />
        <View style={{ marginTop: appTheme.pixelPerfect(5), width: "80%", justifyContent: "flex-start", flex: 1, paddingHorizontal:2 }}>
            <Text numberOfLines={3} style={{ fontFamily: appTheme.primaryBoldFont, color: levelConfiguration.text_color, textAlign: "center", fontSize: appTheme.pixelPerfectForFont(7) }}>{activity.title[getLanguage()]}</Text>
        </View>
    </TouchableOpacity>

}

export default ActivitySquareButton;

